// Keys are slash paths relative to the granted root, so "" is the root itself
// and empty segments (leading, trailing, doubled) carry no meaning.
export const SplitPath = (path: string): string[] => path.split("/").filter(part => part !== "")
